import React from 'react';
import { Eraser } from 'lucide-react';

import BLOCK_TYPES from './blocks/registry';

// Lets the admin choose which block type to drop onto the PRIMARY cell.
// Lists every *registered* block type (icon + label) — adding a block
// type means adding an entry to blocks/registry.js, never touching this
// component.
export default function AddBlockMenu({ onAddBlock, onClearAll, hasBlocks }) {
  return (
    <div className="ss-print__panel">
      <div className="ss-print__panel-header">
        <h3 className="ss-print__panel-title">Add Element</h3>
        <div className="ss-print__panel-header-actions">
          <button
            type="button"
            className="ss-print__lock-toggle ss-print__lock-toggle--danger"
            onClick={onClearAll}
            disabled={!hasBlocks}
            aria-label="Clear All"
            title="Clear All"
          >
            <Eraser size={16} aria-hidden="true" />
          </button>
        </div>
      </div>
      <div className="ss-print__add-block-menu">
        {BLOCK_TYPES.flatMap(({ type, label, icon: Icon, variants }) =>
          (variants || [{ label, icon: Icon, overrides: undefined }]).map((variant) => (
            <button
              key={`${type}-${variant.label}`}
              type="button"
              className="ss-print__add-block-btn"
              onClick={() => onAddBlock(type, variant.overrides)}
              title={`Add ${variant.label}`}
            >
              <variant.icon size={20} aria-hidden="true" />
              <span>{variant.label}</span>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
